import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var visibilityOffIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: "1.5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 18.843c4.05 0 7.717-2.084 11-6.25-3.283-4.864-6.95-7.295-11-7.295S4.283 7.729 1 12.592c3.283 4.167 6.95 6.25 11 6.25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.5 1.5 21 21",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "4"
})));

export { visibilityOffIcon as default };
//# sourceMappingURL=visibilityOffIcon.js.map
